var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M17.8 19.4 15.9 11l3.6-3.6c1.5-1.5 2-3.4 1.5-4.5-1-.5-3 0-4.5 1.5L12.9 8 4.5 6.1a.8.8 0 0 0-.8.4l-.3.5c-.2.4 0 .9.3 1.1L9 11l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.4 5.1c.2.4.7.5 1.1.3l.5-.2c.4-.2.5-.6.4-1z",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }